import React from 'react';
import PropTypes from 'prop-types';

import Spinner from './spinner';

const SpinnerContainer = ({
	padding = true,
}) => (
	<div className={`flex-row justify-center ${padding ? 'padding-vertical-32' : ''}`}>
		<div className={`align-center ${padding ? 'padding-vertical-64' : 'padding-vertical-16'}`}>
			<Spinner />
		</div>
	</div>
);

export default SpinnerContainer;

SpinnerContainer.propTypes = {
	padding: PropTypes.bool,
};
